module.exports = __webpack_public_path__ + "img/logo.8267acb7.png";